<template>
  <section-page
    title="Contact Custom Fields"
    description="Custom fields are input fields you can add and arrange in the Contact Details section for all contacts. For custom fields related to specific contact types, scroll down to the Contact Types settings."
  >
    <template v-slot:right>
      <button-outlined icon-left="plus" @click="$refs.customFieldModal.open(defaultFormData)">
        New Custom Field
      </button-outlined>
    </template>

    <app-empty-message
      :count="customFields.length"
      heading="You don't have any fields. Why don't you make one."
    >
      <table-default
        :table-data="customFields"
        default-sort="index"
        empty-message="You don't have any custom fields.<br>Why don't you make one."
      >
        <b-table-column label="Order" field="order" width="80" sortable v-slot="props">
          {{ props.row.index }}
        </b-table-column>

        <b-table-column label="Name" field="label" sortable v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Type" field="type" sortable v-slot="props">
          {{ props.row.type | newEnumLabel(ENUMS.CustomFieldTypeEnum) }}
        </b-table-column>

        <b-table-column label="Options" field="options" sortable v-slot="props">
          {{ props.row.options.toString() }}
        </b-table-column>

        <b-table-column label="Default Value" field="default_value" sortable v-slot="props">
          {{ props.row.default_value }}
        </b-table-column>

        <b-table-column label="Visible" field="visible" centered sortable v-slot="props">
          <icon-default
            icon="check"
            size="is-small"
            color="is-success"
            v-if="props.row.visible"
          ></icon-default>
        </b-table-column>

        <b-table-column cell-class="action_cell" width="120" v-slot="props">
          <button-link @click="$refs.customFieldModal.open(props.row)">Manage</button-link>
        </b-table-column>

      </table-default>
    </app-empty-message>

    <modal-container>
      <modal-crud-form
        ref="customFieldModal"
        title="Custom Field"
        form-component="custom-field-form">
      </modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: "ContactCustomFields",
  data() {
    return {
      defaultFormData: {
        custom_fieldable_type: ENUMS.CustomFieldableTypeEnum.Contact.value,
        custom_fieldable_id: null
      }
    };
  },
  computed: {
    customFields() {
      return [...this.$store.getters.contactCustomFields].map((cf, index) => {
        cf.index = index + 1;
        return cf;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
